module.exports = __webpack_public_path__ + "static/index/img/baikal-305.b1b9e40d.jpg";